import { render } from "./RingListBody.vue?vue&type=template&id=c77a8b06"
import script from "./RingListBody.vue?vue&type=script&lang=js"
export * from "./RingListBody.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Data\\Bibliothèque\\Téléchargements\\public\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__